import heic2any from 'heic2any'
export default {
  data() {
    return {
      imageUrl: null,
      isHEIC: false
    }
  },
  methods: {
    checkHEIC(url, type) {
      if (type === 'image/heic' || type === 'image/heif') {
        const encodedURL = this.urlEncoding(url)
        this.isHEIC = true
        this.handelHEIC(encodedURL)
      } else {
        this.isHEIC = false
      }
    },
    handelHEIC(url) {
      let headers = this.$store.getters['auth/auth']
      fetch(url, {
        headers: {
          'access-token': headers['access-token'],
          client: headers['client'],
          expiry: headers['expiry'],
          uid: headers['uid'],
          'token-type': headers['token-type']
        }
      })
        .then(res => res.blob())
        .then(blob =>
          heic2any({
            blob,
            toType: 'image/png',
            quality: 0.1
          })
        )
        .then(conversionResult => {
          let url = URL.createObjectURL(conversionResult)
          this.imageUrl = url
        })
        .catch(e => {
          console.log(e)
        })
    },
    urlEncoding(url) {
      return url.replace('\\u0026', '&')
    }
  }
}
